<div class="container-checklist no-print">
    <div class="container">
        <div class="container-checklist__single-checklist d-flex" *ngFor="let item of block; let idx = index">
            <div
                class="container-checklist__single-checklist__box-marker d-flex flex-column align-items-center {{ classColumnBoxMarker }}">
                <h2 class="m-0 text-neutral-A1 ls-h2-section-title">
                    {{ (idx + 1 < 10) ? '0' + (idx + 1) : idx + 1 }} </h2>
                        <div [ngClass]="{'lineBottom': block.length > 1 && idx + 1 !== block.length}"></div>
            </div>
            <div class="container-checklist__single-checklist__box-text rounded-3 mb-5 {{ classColumnText }} ">
                <h3 *ngIf="item.titolo_step" innerHTML="{{ item.titolo_step }}"
                    class="container-checklist__single-checklist__box-text__title ls-h3-item-title-small text-neutral-30">
                    
                </h3>
                <p *ngIf="item.testo_step"
                    class="container-checklist__single-checklist__box-text__text text-neutral-40 ls-p"
                    [innerHTML]="item.testo_step"></p>
            </div>
        </div>
    </div>
</div>
<ng-container *ngFor="let item of block; let idx = index">
    <app-sample-print [title]="item.titolo_step" [description]="item.testo_step"></app-sample-print>
</ng-container>